import styled from 'styled-components';

const CountryDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export default CountryDetails;
